(function () {
    angular.module('app')
        .directive('imageSource', imageSource);

    var id = 0;
    imageSource.$inject = ['helper', '$window', '$parse', '$q', '$timeout'];
    function imageSource(helper, $window, $parse, $q, $timeout) {
        var directive = {
            priority: 99,
            restrict: 'A',
            link: link
        };
        return directive;

        function link($scope, $element, $attrs, carousel) {
            var directiveId = id;
            id++;
            var expression;
            var settings = $parse($attrs.imageSource)($scope);
            var queries = helper.getMediaQueries();
            var url;
            var win = angular.element($window);
            var deferred = $q.defer();
            var cancelListener = $scope.$on('carouselV2.updated', checkPosition)
            deferred.promise.then(cancelListener);
            var placeholder = angular.element('<div class="image-placeholder"><div class="lds-ripple"><div></div><div></div></div></div>');
            var placeholderImage = placeholder.find('img');
            var positioned = false;
            //used 30 instead of 0 to get around microsoft edge image sizing bug, where images had a height of 30 before the source is loaded
            if ($element.height() > 30) {
                positioned = true;
                placeholderImage.css({
                    top: -$element.outerHeight() / 2 - 17
                });
            }
            $element.on('transitionend.imageSource', function () {
                placeholder.remove();
                $element.off('transitionend.imageSource');
            });
            if ($element.is('img')) {
                $element.after(placeholder);
            }
            else {
                $element.append(placeholder);
            }
            function setSource() {
                deferred.promise.then(function () {
                    if (url) {
                        $element.removeClass('loaded');
                        var image = new Image();
                        image.onload = image.onerror = function () {
                            $element.addClass('loaded');
                            if (!positioned) {
                                positioned = true;
                                placeholderImage.css({
                                    position: 'absolute',
                                    top: -$element.outerHeight() / 2 - 17
                                });
                            }
                            placeholder.remove();
                        };
                        image.src = url;
                        if ($element.is('img')) {
                            $element.attr('src', url)
                        }
                        else {
                            $element.css('backgroundImage', "url('" + url + "')");
                        }
                        scroller.off('scroll.imageSource' + directiveId);
                    }
                });
            }

            function checkPosition() {
                var rect = $element[0].getBoundingClientRect();
                if (rect.top <= win.height() && rect.left <= win.width() && rect.bottom <= win.height() + rect.height && rect.right >= 0) {
                    deferred.resolve();
                }
            }

            var scroller = win.on('scroll.imageSource' + directiveId, checkPosition);
            var previousSize;

            //var offsets = scroller[0].getBoundingClientRect();
            if (settings) {
                if (typeof (settings) === 'string') {
                    url = settings;
                    setSource();
                }
                else {
                    var retina = $window.matchMedia('only screen and (min-resolution: 124dpi), only screen and (min-resolution: 1.3dppx), only screen and (min-resolution: 48.8dpcm)');
                    function getUrl() {
                        var keys = Object.keys(queries);
                        var result;
                        for (var i = 0; i < keys.length; i++) {
                            var key = keys[i];
                            if (key.indexOf("down") === -1 && key.indexOf("up") === -1 && key.indexOf("only") === -1) {
                                if (queries[key].matches) {
                                    if (settings[key]) {
                                        result = key;
                                    }
                                }
                                else {
                                    break;
                                }
                            }
                        }
                        if (result) {
                            if (retina.matches && settings[result + 'retina']) {
                                result = result + 'retina';
                            }
                            url = settings[result];
                        }
                        if (previousSize !== result) {
                            setSource();
                        }
                        previousSize = result;
                    }

                    win.on('resize.imageSource' + directiveId, getUrl);
                    getUrl();
                }
                $timeout(function () {
                    checkPosition();
                });
            }
            $scope.$on('$destroy', function () {
                win.off('resize.imageSource' + directiveId);
                scroller.off('scroll.imageSource' + directiveId);
                scroller.off('scroll.imageSource' + directiveId);
                $element.off('transitionend.imageSource');
                cancelListener();
            });
        }
    }
})();